import { all, fork } from "redux-saga/effects";
// import { networkSaga } from "react-native-offline";
import SignupSaga from "./signup/sagas";
import LoginSaga from "./login/sagas";
import UserSaga from "./user/sagas";
import HistoricalSaga from "./historical/sagas";
// import SearchSaga from './search/sagas';
import ProfileSettingsSaga from "./profileSettings/sagas";
import ExternalProfileSaga from "./externalProfile/sagas";
import ActionSaga from "./action/sagas";
import RankingSaga from "./ranking/sagas";
import RealTimeSaga from "./realTime/sagas";
import FeelingSaga from "./feeling/sagas";
import MessageSaga from "./message/sagas";
import NotificationSaga from "./notification/sagas";
import TeamSaga from "./team/sagas";
import RandomCoffeeSaga from "./randomCoffee/sagas";
import GlossarySaga from "./glossary/sagas";
import IdeaSaga from "./idea/sagas";
import PollSaga from "./poll/sagas";
import TokenSaga from "./token/sagas";
import UserCampaign from "./userCampaign/sagas";
import LibrarySaga from "./library/sagas";
import ClientSaga from "./client/sagas";
import SurveySaga from "./survey/sagas";
import CoachingSaga from "./coaching/sagas";
import ResourcesSaga from "./resources/sagas";
import UploadSaga from "./upload/sagas";
import GeneralSaga from "./general/sagas";

export default function* rootSagas() {
  yield all([
    TokenSaga(),
    SignupSaga(),
    LoginSaga(),
    UserSaga(),
    ProfileSettingsSaga(),
    HistoricalSaga(),
    ExternalProfileSaga(),
    ActionSaga(),
    RankingSaga(),
    RealTimeSaga(),
    FeelingSaga(),
    MessageSaga(),
    TeamSaga(),
    NotificationSaga(),
    RandomCoffeeSaga(),
    GlossarySaga(),
    IdeaSaga(),
    PollSaga(),
    UserCampaign(),
    LibrarySaga(),
    ClientSaga(),
    SurveySaga(),
    CoachingSaga(),
    ResourcesSaga(),
    UploadSaga(),
    GeneralSaga(),
    // networkSaga(),
    // listenServerSaga(),
    // fork(networkSaga)
  ]);
}
